module.exports = __webpack_public_path__ + "static/media/icon-google.5f64a793.svg";